<template>
  <div class="policy-page">
    <v-container class="py-10" style="max-width: 860px;">

      <!-- Loading -->
      <div v-if="isLoading" class="d-flex justify-center py-16">
        <v-progress-circular indeterminate size="48" width="4" color="#F4811F" />
      </div>

      <!-- Error -->
      <div v-else-if="error" class="text-center py-16">
        <v-icon size="56" color="grey lighten-1">mdi-alert-circle-outline</v-icon>
        <p class="mt-4 grey--text">{{ error }}</p>
        <v-btn outlined color="#F4811F" @click="fetchPolicy">ลองใหม่อีกครั้ง</v-btn>
      </div>

      <!-- Content -->
      <div v-else-if="policy">
        <div class="policy-header mb-8">
          <h1 class="policy-title">{{ policy.title }}</h1>
          <p class="policy-date">วันที่เริ่มใช้บังคับ: {{ formatDate(policy.effectiveDate) }}</p>
        </div>

        <v-divider class="mb-8" />

        <div class="policy-body">{{ policy.content }}</div>
      </div>

      <!-- Fallback -->
      <div v-else class="text-center py-16">
        <v-icon size="56" color="grey lighten-1">mdi-file-document-outline</v-icon>
        <p class="mt-4 grey--text">ไม่พบข้อมูล</p>
      </div>

    </v-container>
  </div>
</template>

<script>
import { getPolicyByTypeApi } from "@/services/api/policy";

const TYPE_MAP = {
  terms: "terms",
  privacy: "privacy",
  payment: "payment",
};

export default {
  name: "PolicyPage",

  data() {
    return {
      isLoading: false,
      error: null,
      policy: null,
    };
  },

  computed: {
    policyType() {
      return TYPE_MAP[this.$route.meta.policyType] || "terms";
    },
  },

  watch: {
    policyType() {
      this.fetchPolicy();
    },
  },

  created() {
    this.fetchPolicy();
  },

  methods: {
    async fetchPolicy() {
      this.isLoading = true;
      this.error = null;
      this.policy = null;
      try {
        const res = await getPolicyByTypeApi(this.policyType);
        this.policy = res.data.data;
      } catch (err) {
        this.error = "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง";
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.policy-page {
  min-height: 60vh;
  background: #fff;
}

.policy-header {
  text-align: center;
}

.policy-title {
  font-size: clamp(20px, 2.5vw, 28px);
  font-weight: 700;
  color: #111827;
  font-family: "Noto Sans Thai", "Kanit", sans-serif;
  line-height: 1.4;
  margin-bottom: 8px;
}

.policy-date {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.policy-body {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 15px;
  line-height: 2;
  color: #1f2937;
  font-family: "Noto Sans Thai", "Sarabun", sans-serif;
  text-align: justify;
}
</style>
